import { JsonObject } from '../helpers';
import { PolicyModel } from '../models/policy.model';
import { get } from './sp-api.service';

export const getUserPolicy = async (): Promise<PolicyModel | null> => {
  const response = await get(`/policy/portal`);
  return response ? new PolicyModel(response as JsonObject) : null;
};
